<template>
  <div>
    <div class="globalLoading" v-show="is_loading">
      <span>
        <img src="./assets/img/loading.gif">
      </span>
    </div>
    <router-view :class="is_app ? 'inApp':''" slot="main" :title="title" :transition="'page-pop-' + (direction === 'forward' ? 'in' : 'out')"></router-view>
  </div>
</template>

<script>
    import store from './store/index'
    import { mapActions, mapGetters } from 'vuex'
    import { setupWebViewJavascriptBridge } from './assets/js/util'
    import { showTips } from './assets/js/util.js'
    export default {
      components: {
      },
      store: store,
      data () {
        return {
          first_init: true,
          init_wx: false,
          init_dudu_app: false,
          routerTransition: {
            forward: 'slideRL',
            back: 'slideLR'
          },
          direction: 'forward'
        }
      },
      computed: {
        ...mapGetters({
          os: 'os',
          qiyu_group_id: 'qiyu_group_id',
          is_app: 'is_app',
          reload_page: 'reload_page',
          handleTokenError: 'handleTokenError'
        }),
        title () {
          return this.$route.meta ? this.$route.meta.title : ''
        },
        is_loading () {
          return this.$store.state.common.is_loading
        }
      },
      methods: {
        ...mapActions([
          'clearOrder',
          'initQiYuScript',
          'changeHeight'
        ])
      },
      watch: {
        reload_page () {
          var _self = this
          showTips('登录失效，请重新登录')
          setTimeout(function () {
            if (_self.handleTokenError) {
              if (_self.os === '1') {
                setupWebViewJavascriptBridge(function (bridge) {
                  bridge.callHandler('requestAppLogin', {
                    data: '0005',
                    info: '登录失效，请重新登录'
                  })
                  bridge.registerHandler('appLoginResult', function (data) {
                    _self.setUserInfo(data)
                    _self.$router.go(0)
                  })
                })
              } else if (_self.os === '2') {
                try {
                  window.app.appLoginResult = function (data) {
                    _self.setUserInfo(data)
                    _self.$router.go(0)
                  }
                  window.app.requestAppLoginExit()
                } catch (e) {
                  console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
                }
              }
            } else {
              window.location.reload()
            }
          }, 1000)
        }
      },
      created () {
        window.addEventListener('resize', this.changeHeight)
        // app继续包车时调取h5
        var _self = this
        if (_self.os === '1') {
          setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler('continueCharter', function (data, responseCallback) {
              _self.clearOrder()
              window.history.go(-1)
              // responseCallback(data)
            })
          })
        }
        // 七鱼的script，很慢导致页面空白太久
        window.setTimeout(function () {
          _self.initQiYuScript()
        }, 1000)
      },
      updated () {
        setTimeout(function () {
          window.document.body.scrollTop = 0
          window.document.documentElement.scrollTop = 0
        }, 500)
      }
    }
</script>

<style lang="scss">
  @import './assets/scss/base.scss';
  .globalLoading {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    span {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 41px;
      margin: -21px 0 0 -21px;
      img {
        width: 100%;
      }
    }
  }
  .inApp .container{
    padding-top: 0px;
  }
  .container {
    padding-top: 40px;
    width: 100%;
    background: #ECEFF4;
    overflow: auto;
    z-index: 99;
  }
    /* v-r-transition, default is {forward: 'forward', back: 'back'}*/
  .forward-enter, .forward-leave {
      transform: translate3d(-100%, 0, 0);
  }
  .back-enter, .back-leave {
      transform: translate3d(100%, 0, 0);
  }

  /**
  * vue-router transition
  */
  .page-pop-out-transition,
  .page-pop-in-transition {
      width: 100%;
      animation-duration: 0.5s;
      animation-fill-mode: both;
      backface-visibility: hidden;
  }
  .page-pop-out-enter,
  .page-pop-out-leave,
  .page-pop-in-enter,
  .page-pop-in-leave {
      will-change: transform;
      height: 100%;
      position: absolute;
      left: 0;
  }
  .page-pop-out-enter {
      animation-name: popInLeft;
  }
  .page-pop-out-leave {
      animation-name: popOutRight;
  }
  .page-pop-in-enter {
      perspective: 1000;
      animation-name: popInRight;
  }
  .page-pop-in-leave {
      animation-name: popOutLeft;
  }
  @keyframes popInLeft {
      from {
          transform: translate3d(-100%, 0, 0);
      }
      to {
          transform: translate3d(0, 0, 0);
      }
  }
  @keyframes popOutLeft {
      from {
          transform: translate3d(0, 0, 0);
      }
      to {
          transform: translate3d(-100%, 0, 0);
      }
  }
  @keyframes popInRight {
      from {
          transform: translate3d(100%, 0, 0);
      }
      to {
          transform: translate3d(0, 0, 0);
      }
  }
  @keyframes popOutRight {
      from {
          transform: translate3d(0, 0, 0);
      }
      to {
          transform: translate3d(100%, 0, 0);
      }
  }
</style>


// WEBPACK FOOTER //
// App.vue?3f766243